/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect, useLayoutEffect, useRef} from 'react'
import clsx from 'clsx'
import {toAbsoluteUrl, defaultMessages, defaultUserInfos, UserInfoModel, KTSVG} from '../../helpers'
import Firebase from '../../../app/services/firebase'

import {useTranslation, initReactI18next} from 'react-i18next'
import {format, formatDistance, formatRelative, subDays} from 'date-fns'
import {id, enUS as en} from 'date-fns/locale'
import axios from 'axios'
import i18next from 'i18next'
import {Button, Modal, Spinner} from 'react-bootstrap'
import './chat-inner.css'

type Props = {
  isDrawer?: boolean
  roomId?: string
  cusId?: any
  poNumb?: string
  list?: any
  sales?: string
  codeSales?: any
  canReply?: boolean
  isHistory?: boolean
}

interface MessageModel {
  id?: string
  userId?: string
  message: string
  timestamp?: string
  time?: string
}

const bufferMessages = defaultMessages

const ChatInner: FC<Props> = ({
  isDrawer = false,
  roomId = null,
  cusId = null,
  poNumb = null,
  list = [],
  sales = null,
  codeSales = null,
  canReply = true,
  isHistory = false,
}) => {
  const userId = localStorage.getItem('user-id')
  const role = localStorage.getItem('role-flag')
  const [chatUpdateFlag, toggleChatUpdateFlat] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [messages, setMessages] = useState<MessageModel[]>(isHistory ? list || [] : [])
  const [userInfos] = useState<UserInfoModel[]>(defaultUserInfos)
  const [isSending, setIsSending] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)
  const [sending, setSending] = useState(false)
  const name: any = localStorage.getItem('username')
  const credentials = localStorage.getItem('credential') as string

  const [selectedIndex, setSelectedIndex] = useState<any>(null)
  const [messageToEdit, setMessageToEdit] = useState<any>(null)
  const [messageToDelete, setMessageToDelete] = useState<any>(null)
  const [showConfirmDelete, setShowConfirmDelete] = useState(false)

  const sendMessage = async () => {
    const tmp = message.replace(/\r?\n/g, '<br />')
    setIsSending(true)
    setSending(true)
    if(!messageToEdit){
      const send = await Firebase.sendMessage({
        roomId,
        userId,
        message: tmp,
      })
      if (send) {
        const allMessages = messages
        allMessages.push(send)
        setMessages(allMessages)
        if (role == 'salesAdmin') {
          if (list[0]?.item == true || list?.item == true) {
            if (roomId === poNumb) {
              axios.get(
                `${
                  process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
                }/order-submission/negotiate/notif/message??credentials=${credentials}&room_id=${roomId}&customer_id=${cusId}&type=${'increment'}&flag=header&role_flag=customer&message=${tmp}`
              )
            } else {
              axios.get(
                `${
                  process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
                }/order-submission/negotiate/notif/message?credentials=${credentials}&room_id=${roomId}&customer_id=${cusId}&type=${'increment'}&parent_id=${poNumb}&header_id=${poNumb}&flag=item&role_flag=customer&message=${tmp}`
              )
            }
          } else {
            axios.get(
              `${
                process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
              }/order-submission/negotiate/notif/message?credentials=${credentials}&room_id=${roomId}&customer_id=${cusId}&type=${'increment'}&parent_id=${poNumb}&header_id=${poNumb}&flag=item&role_flag=customer&message=${tmp}`
            )
          }
        } else {
          if (list[0]?.item == true || list?.item == true) {
            if (roomId === poNumb) {
              axios.get(
                `${
                  process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
                }/order-submission/negotiate/notif/message?credentials=${credentials}&room_id=${roomId}&customer_id=${codeSales}&type=${'increment'}&flag=header&role_flag=salesAdmin&message=${tmp}`
              )
            } else {
              axios.get(
                `${
                  process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
                }/order-submission/negotiate/notif/message?credentials=${credentials}&room_id=${roomId}&customer_id=${codeSales}&type=${'increment'}&parent_id=${poNumb}&header_id=${poNumb}&flag=item&role_flag=salesAdmin&message=${tmp}`
              )
            }
          } else {
            axios.get(
              `${
                process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT
              }/order-submission/negotiate/notif/message?credentials=${credentials}&room_id=${roomId}&customer_id=${codeSales}&type=${'increment'}&parent_id=${poNumb}&header_id=${poNumb}&flag=item&role_flag=salesAdmin&message=${tmp}`
            )
          }
        }
      }
    }else{
      const _chat = {
        ...messageToEdit,
        message: tmp
      }
      await Firebase.updateMessage(roomId, _chat)
      
      const _messages = [...messages]
      _messages[selectedIndex] = _chat
      setMessages(_messages)

      setSelectedIndex(null)
      setMessageToEdit(null)
    }
    setSending(false)
    setMessage('')
    setIsSending(false)
  }

  const onEnterPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault()
      sendMessage()
    }
  }

  useEffect(() => {
    if (roomId) {
      const unsubscribe = Firebase.getMessages(roomId, setMessages)
      return unsubscribe
    } else {
      setMessages(isHistory ? list || [] : [])
    }
  }, [roomId])

  useLayoutEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight
    }
  })

  const {t} = useTranslation()

  const [language, setLanguage] = useState<any>()

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split(';').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const formatDate = (d: any) => {
    if (language == 'en') {
      const ndate = format(new Date(d), 'PPp')
      return ndate
    } else {
      const ndate = format(new Date(d), 'PPp', {locale: id})
      return ndate
    }
  }

  const editMessage = (item: any, index: any) => {
    setSelectedIndex(index)
    setMessageToEdit(item)
    setMessage(item.message)
  }
  const closeEditMessage = () => {
    setMessageToEdit(null)
    setMessage('')
    setSelectedIndex(null)
  }
  const deleteMessage = (item: any, index: any) => {
    setSelectedIndex(index)
    setMessageToDelete(item)
    setShowConfirmDelete(true)
  }
  const cancelDeleteMessage = () => {
    setSelectedIndex(null)
    setMessageToDelete(null)
    setShowConfirmDelete(false)
  }
  const handleDeleteMessage = async () => {
    setIsDeleting(true)
    const deleted = await Firebase.deleteMessage(roomId, messageToDelete.id)
    if(deleted){
      const _messages = [...messages]
      _messages.splice(selectedIndex, 1)
      setMessages(_messages)
  
      setShowConfirmDelete(false)
      setSelectedIndex(null)
      setMessageToDelete(null)
    }
    setIsDeleting(false)
  }

  const isSelfChat = (message: MessageModel):  boolean => {
    return (message.userId == userId || (message.userId == codeSales && role != 'null'))
  }

  return (
    <>
      <div
        className='card card-flush px-5 pb-5 '
        style={{maxHeight: '69vh'}}
        id={isDrawer ? 'kt_drawer_chat_messenger_body' : 'kt_chat_messenger_body'}
      >
        <div
          ref={containerRef}
          className={clsx('scroll-y me-n5 pe-5 mt-2', {'h-300px h-lg-auto': !isDrawer})}
          data-kt-element='messages'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies={
            isDrawer
              ? '#kt_drawer_chat_messenger_header, #kt_drawer_chat_messenger_footer'
              : '#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer'
          }
          data-kt-scroll-wrappers={
            isDrawer ? '#kt_drawer_chat_messenger_body' : '#kt_content, #kt_chat_messenger_body'
          }
          data-kt-scroll-offset={isDrawer ? '0px' : '-2px'}
        >
          {messages.length == 0 && (
            <div className='alert alert-primary text-center' role='alert'>
              {t('Belum ada chat')}
            </div>
          )}

          {messages.map((message, index) => {
            const userInfo = userInfos[0]
            const state = isSelfChat(message) ? 'primary' : 'info'
            const templateAttr = {}
            Object.defineProperty(templateAttr, 'data-kt-element', {
              value: `template-${isSelfChat(message) ? 'out' : 'in'}`,
            })
            const contentClass = `${isDrawer ? '' : 'd-flex'} justify-content-${isSelfChat(message) ? 'end' : 'start'} mb-10`
            return (
              <div
                key={`message${index}`}
                className={clsx('d-flex', contentClass, 'mb-10')}
                {...templateAttr}
              >
                <div
                  className={clsx(
                    'd-flex flex-column align-items',
                    `align-items-${isSelfChat(message) ? 'end' : 'start'}`
                  )}
                >
                  {/* <div className='d-flex align-items-center mb-2'>
                    {(message.userId != userId) ? (
                      <>
                        <div className='symbol  symbol-35px symbol-circle '>
                          <img alt='Pic' src={toAbsoluteUrl(`/media/${userInfo.avatar}`)} />
                        </div>
                        <div className='ms-3'>
                          <a
                            href='#'
                            className='fs-5 fw-bolder text-gray-900 text-hover-primary me-1'
                          >
                            {userInfo.name}
                          </a>
                          <span className='text-muted fs-7 mb-1'>{message.timestamp}</span>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className='me-3'>
                          <span className='text-muted fs-7 mb-1'>{message.timestamp}</span>
                          <a
                            href='#'
                            className='fs-5 fw-bolder text-gray-900 text-hover-primary ms-1'
                          >
                            You
                          </a>
                        </div>
                        <div className='symbol  symbol-35px symbol-circle '>
                          <img alt='Pic' src={toAbsoluteUrl(`/media/${userInfo.avatar}`)} />
                        </div>
                      </>
                    )}
                  </div> */}

                  <div
                    className={clsx(
                      'px-5 rounded',
                      'chat-item',
                      `bg-light-${state}`,
                      'text-dark fw-bold mw-lg-400px',
                      `text-${isSelfChat(message) ? 'end' : 'start'}`,
                      messageToEdit && messageToEdit.id == message.id ? 'bg-primary' : ''
                    )}
                    data-kt-element='message-text'
                  >
                    {(message.userId == userId && role == 'salesAdmin') && (
                      !messageToEdit
                      || (messageToEdit && messageToEdit.id != message.id)
                    ) && (
                      <>
                        <button
                          className='p-2 btn text-warning chat-action'
                          onClick={() => editMessage(message, index)}
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={'Aksi'}
                        >
                          <i className='bi bi-pencil-fill'></i>
                        </button>
                        <button
                          className='p-2 btn text-danger chat-action'
                          onClick={() => deleteMessage(message, index)}
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={'Aksi'}
                        >
                          <i className='bi bi-trash-fill'></i>
                        </button>
                      </>
                    )}
                    <div className={'pb-5 ' + (messageToEdit && messageToEdit.id == message.id ? 'text-white' : '')} dangerouslySetInnerHTML={{__html: message.message}}></div>
                  </div>
                  <div>
                    {formatDate(message.time)}{' '}
                    {role != 'null' && message.userId == codeSales ? '- ' + sales : ''}
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        <hr style={{border: 'none', borderBottom: '4px solid black'}} />

        {canReply && (<>
          { messageToEdit ? <div className='d-flex bg-light-primary px-2 justify-content-between align-items-center'>
            <i>editing message</i>
            <button
              className='p-2 btn text-primary'
              onClick={() => closeEditMessage()}
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title={'Aksi'}
            >
              <i className='bi bi-x-circle-fill'></i>
            </button>
          </div> : <></> }
          <div
            className='card-footer d-flex pt-4'
            id={isDrawer ? 'kt_drawer_chat_messenger_footer' : 'kt_chat_messenger_footer'}
          >
            <textarea
              className={'form-control form-control-flush me-3'}
              rows={1}
              data-kt-element='input'
              placeholder={t('Type a message')}
              value={sending ? '' : message}
              disabled={isSending}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={onEnterPress}
            ></textarea>

            <div className='d-flex justify-content-end'>
              <button
                className={"btn btn-primary"}
                type='button'
                disabled={isSending || !message}
                data-kt-element='send'
                onClick={sendMessage}
              >
                {!isSending ? t('send') : <Spinner animation='border' variant='light' size='sm' />}
              </button>
            </div>
          </div>
        </>
        )}
      </div>

      <Modal show={showConfirmDelete} onHide={() => cancelDeleteMessage()} centered backdrop='static'>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className='border border-top-0 border-bottom-0 border-1 border-secondary'>
            <h3 className='text-center mb-5'>{t('Are you sure?')}</h3>
          </Modal.Body>
          <Modal.Footer className='border border-top-1 border-1 border-secondary'>
            <Button
              variant='secondary'
              onClick={() => {
                cancelDeleteMessage()
              }}
            >
              {t('Tidak')}
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                handleDeleteMessage()
              }}
              disabled={isDeleting}
            >
              {isDeleting ? <Spinner animation='border' variant='light' size='sm' /> : t('Ya')}
            </Button>
          </Modal.Footer>
        </Modal>
    </>
  )
}

export {ChatInner}
